import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { css } from "styled-components";

Object.assign(logoStyles, {
    wrapper: {
        css: css`
            height: 100%;
            line-height: 0;

            a {
                display: inline-block;
                height: 100%;
            }

            span {
                display: flex;
                align-items: center;
                height: 100%;
            }

            img {
                max-height: 100%;
                height: 100%;
                width: auto;
            }
        `,
    },
});
